import React from 'react';
import { ICommunication } from 'types';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
} from '@mui/material';
import Scrollbars from 'react-custom-scrollbars-2';
import './index.css';
import { useTranslation } from 'react-i18next';
import { useAppInitiator } from 'providers/AppInitiator';
import Paths from 'lib/paths';
import axios from 'axios';

const Communication = ({
  content,
  title,
  choice,
  communicationId,
}: ICommunication) => {
  const [open, setOpen] = React.useState(true);
  const [checked, setChecked] = React.useState(false);

  const { boot } = useAppInitiator();

  const deleteCommunicationUrl = `${Paths.join(
    boot.backends.api.baseUrl,
    '/api/eds/v1/communications',
  )}`;

  const handleClose = () => {
    setOpen(false);

    axios
      .post(deleteCommunicationUrl, {
        communicationId: communicationId,
      })
      .then(
        (response) => {
          window.location.reload();
          console.log(response);
        },
        (error) => {
          window.location.reload();
          console.log(error);
        },
      );
  };

  const renderThumb = () => {
    return <div style={{ backgroundColor: '#1A416B', borderRadius: '16px' }} />;
  };

  const { t } = useTranslation();

  return (
    <Dialog open={open} className="Background">
      <DialogTitle className="TitleCommunication">{title}</DialogTitle>
      <DialogContent className="DialogContent">
        <div className="BackgroundOpacity"></div>
        <Scrollbars
          renderThumbVertical={renderThumb}
          autoHeightMin={0}
          autoHeightMax={800}
        >
          {content}
        </Scrollbars>
      </DialogContent>

      <DialogActions
        // className="DialogActions"
        style={{ justifyContent: 'left' }}
      >
        <FormControlLabel
          style={{ alignItems: 'center' }}
          className="LabelCheckbox"
          value="confirm"
          onChange={() => setChecked(!checked)}
          control={
            <span>
              <Checkbox
                style={{
                  transform: 'scale(0.8)',
                }}
                sx={{
                  '&.Mui-checked': {
                    color: '#1A416B',
                  },
                }}
                checked={checked}
              />
            </span>
          }
          label={choice}
          labelPlacement="end"
        />
      </DialogActions>
      <DialogActions
        className="DialogActions"
        style={{ justifyContent: 'center' }}
      >
        <Button
          size="large"
          fullWidth={true}
          style={{ width: '178px' }}
          onClick={handleClose}
          disabled={!checked}
        >
          {t('submit', 'Submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Communication;
